module.exports = __webpack_public_path__ + "static/1-c481fa059f0a3c01e203584dede3db52.jpg";